import { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { API, authHeaders, getToken, clearToken, useNoIndex } from './auth';
import { useToast } from '../hooks/use-toast';

export const useMe = () => {
  const navigate = useNavigate();
  const [me, setMe] = useState(null);
  useNoIndex();
  useEffect(() => {
    if (!getToken()) { navigate('/login'); return; }
    axios.get(`${API}/user/me`, { headers: authHeaders() })
      .then(({ data }) => {
        if (data.role === 'admin') { navigate('/admin'); return; }
        setMe(data);
      })
      .catch(() => { clearToken(); navigate('/login'); });
  }, [navigate]);
  return [me, setMe];
};

export const useFlash = () => {
  const { toast } = useToast();
  return (message) => toast({ title: message });
};
